// frontend/api/payment.js
import axios from "axios";
import { getLicenseApiUrl } from "../config/api";

const LICENSE_API = getLicenseApiUrl();

/**
 * Step 1: Purchase License - Creates the license purchase and pending transaction
 * This must be called BEFORE creating the Razorpay order
 */
export const purchaseLicense = async ({ 
  name,           // User's full name
  email,          // User's email
  orgName = "",   // Organization name (optional)
  licenseId,      // License type ID
  billingCycle,   // monthly/quarterly/yearly
  source = "Geotrack",  // Product name
  amount,         // Total amount in paise
  currency = "INR"
}) => {
  try {
    const payload = {
      name,
      email,
      orgName,
      licenseId,
      billingCycle,
      source,
      amount,
      currency
    };
    
    const response = await axios.post(
      `${LICENSE_API}/api/lms/purchase-license`,
      payload
    );

    return response.data.data || response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Step 2: Create Razorpay order
 * This uses the pending transaction created in step 1 (purchaseLicense)
 */
export const createOrder = async ({ userId, licenseId, billingCycle, amount }) => {
  try {
    const response = await axios.post(
      `${LICENSE_API}/api/payment/create-order`,
      {
        userId,
        licenseId,
        billingCycle,
        amount,
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Step 3: Verify payment after user completes Razorpay checkout
 */
export const verifyPayment = async (paymentData) => {
  try {
    const response = await axios.post(
      `${LICENSE_API}/api/payment/verify`,
      paymentData
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Initialize Razorpay script
 */
export const initializeRazorpay = () => {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};